import React, { useEffect, useState } from 'react'
import { useOutletContext } from 'react-router-dom'
import EventList from '../components/Home/EventList'

export default function HomePage() {
  const [events, setEvents] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)
  const { setShowTickerExtras } = useOutletContext()

  useEffect(() => {
    // Hide ticker extras on home page
    setShowTickerExtras(false)

    // Fetch events
    const fetchEvents = async () => {
      try {
        const response = await fetch('/events')
        if (!response.ok) {
          throw new Error('Failed to fetch events')
        }
        const data = await response.json()
        setEvents(data)
        setLoading(false)
      } catch (err) {
        setError(err.message)
        setLoading(false)
      }
    }

    fetchEvents()
  }, [setShowTickerExtras])

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[400px]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p className="text-gray-600">Loading events...</p>
        </div>
      </div>
    )
  }

  if (error) {
    return (
      <div className="max-w-2xl mx-auto">
        <div className="bg-red-50 border-l-4 border-red-500 p-4 rounded">
          <div className="flex">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <p className="text-sm text-red-700">Error loading events: {error}</p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-4 gap-6">
      <div className="lg:col-span-3">
        {events.length > 0 ? (
          <div>
            <h2 className="text-2xl font-bold text-gray-800 mb-6">Live Events</h2>
            <EventList events={events} />
          </div>
        ) : (
          <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded text-center">
            <p className="text-lg text-gray-700">Currently there is no live broadcast</p>
          </div>
        )}
      </div>

      <div className="lg:col-span-1">
        {/* Sponsors Sidebar */}
        <div className="bg-white rounded-lg p-6 shadow-sm text-center">
          <span className="inline-block px-3 py-1 bg-blue-600 text-white text-xs font-semibold rounded-full mb-4">
            Presented by
          </span>
          <div className="mt-4">
            <img 
              src="/images/berkutschi-logo.png" 
              alt="Berkutschi" 
              className="mx-auto max-w-full h-auto"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
